import React from 'react';
import { pillars } from '../data/content';
export function Pillars() {
  return <section className="bg-sage-deep" data-id="element-221" data-mp="2ebnp2y8q5asy">
      <div className="mx-auto max-w-content px-5 py-20 text-center sm:px-8 sm:py-28" data-id="element-222" data-mp="2ecp8bpzw93lr">
        <p className="eyebrow flex items-center justify-center gap-2.5 text-[10px] text-white/70 sm:text-[11px]" data-id="element-223" data-mp="2jaidqgtdhtkz">
          <span className="h-px w-6 bg-white/30" aria-hidden="true" data-id="element-224" data-mp="2o28vv8yjxlmy" />
          Más allá de la decoración
          <span className="h-px w-6 bg-white/30" aria-hidden="true" data-id="element-225" data-mp="2szsawb32q2fy" />
        </p>

        <h2 className="mx-auto mt-4 max-w-3xl text-[31px] font-semibold leading-[1.12] tracking-[-0.015em] text-white sm:text-[42px] sm:leading-[1.08] lg:text-[50px] lg:leading-[1.06]" data-id="element-226" data-mp="2xylo02eg7rfl">
          No se trata de decorar tu casa con objetos{' '}
          <span className="italic text-white/70" data-id="element-227" data-mp="36y8n2hjpgl5h">“especiales”</span>
        </h2>

        <p className="mx-auto mt-6 max-w-2xl text-[15.5px] leading-[1.8] text-white/75 sm:text-[17px]" data-id="element-228" data-mp="17p1w2g45tn8v">
          El Feng Shui te enseña a observar cómo se relacionan la distribución, la luz, los objetos,
          los colores, los cinco elementos y cada ambiente. Armonía Interior convierte esos
          principios en cambios sencillos y aplicables.
        </p>

        <ul className="mx-auto mt-14 grid max-w-3xl grid-cols-2 gap-x-6 gap-y-10 sm:mt-16 sm:grid-cols-4" data-id="element-229" data-mp="sd8xuo5v17zh">
          {pillars.map(pillar => <li key={pillar.label} className="flex flex-col items-center" data-id="element-230" data-mp="ngidhon0vq89">
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-white/10 text-2xl" aria-hidden="true" data-id="element-231" data-mp="1k46n1i90qag7">
                {pillar.icon}
              </span>
              <span className="mt-3.5 font-display text-[17px] font-semibold text-white sm:text-[19px]" data-id="element-232" data-mp="1b409xxh8fchk">
                {pillar.label}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}